import {
  buildListingShareDescription,
  buildListingShareTitle,
  type ListingShareInput,
} from '@redevicer/shared'

export interface ListingShareMetaInput extends ListingShareInput {
  imageUrl?: string | null
}

const DEFAULT_TITLE = 'reDevicer'
const DEFAULT_DESCRIPTION =
  'Pirkite ir parduokite naudotus telefonus su IMEI patikra ir aiškia būklės informacija.'

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  const selector = `meta[${attr}="${key}"]`
  let el = document.querySelector(selector)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setLinkRel(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null
  if (!el) {
    el = document.createElement('link')
    el.rel = rel
    document.head.appendChild(el)
  }
  el.href = href
}

export function applyListingShareMeta(input: ListingShareMetaInput) {
  const title = buildListingShareTitle(input.title)
  const description = buildListingShareDescription(input)
  const imageUrl = input.imageUrl?.trim() || null
  const pageUrl = input.url.trim() || null

  document.title = title
  upsertMeta('property', 'og:title', title)
  upsertMeta('property', 'og:description', description)
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:site_name', 'reDevicer')
  upsertMeta('name', 'description', description)
  upsertMeta('name', 'twitter:card', imageUrl ? 'summary_large_image' : 'summary')
  upsertMeta('name', 'twitter:title', title)
  upsertMeta('name', 'twitter:description', description)

  if (pageUrl) {
    upsertMeta('property', 'og:url', pageUrl)
    setLinkRel('canonical', pageUrl)
  }
  if (imageUrl) {
    upsertMeta('property', 'og:image', imageUrl)
    upsertMeta('name', 'twitter:image', imageUrl)
  }
}

export function resetListingShareMeta() {
  document.title = DEFAULT_TITLE
  upsertMeta('name', 'description', DEFAULT_DESCRIPTION)
  upsertMeta('property', 'og:title', DEFAULT_TITLE)
  upsertMeta('property', 'og:description', DEFAULT_DESCRIPTION)
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('name', 'twitter:card', 'summary')
  upsertMeta('name', 'twitter:title', DEFAULT_TITLE)
  upsertMeta('name', 'twitter:description', DEFAULT_DESCRIPTION)

  for (const key of ['og:url', 'og:image']) {
    document.querySelector(`meta[property="${key}"]`)?.remove()
  }
  for (const key of ['twitter:image']) {
    document.querySelector(`meta[name="${key}"]`)?.remove()
  }
  document.querySelector('link[rel="canonical"]')?.remove()
}
